import { useState } from 'react'
import { Drawer } from '@mui/material'

import { OFFER_SORT } from './offerRewards'

const SORT_OPTIONS = [
  {
    id: OFFER_SORT.RECOMMENDED,
    label: 'Recommended',
    title: 'Recommended for you',
    description: 'Default - set by Playback',
  },
  {
    id: OFFER_SORT.HIGHEST_PAYOUT,
    label: 'Highest payout',
    title: 'Highest total payout',
    description: 'Most piggy banks available',
  },
  {
    id: OFFER_SORT.NEWEST,
    label: 'Newest',
    title: 'Newest first',
    description: 'Most recently added',
  },
]

const CloseIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden>
    <path d="M1 1l10 10M11 1L1 11" stroke="#78716c" strokeWidth="1.6" strokeLinecap="round" />
  </svg>
)

/** The "Recommended" chip next to the All offers title, and the sheet it opens. */
const SortOffers = ({ sort, onChange, canSortByNewest }) => {
  const [isOpen, setOpen] = useState(false)

  const options = SORT_OPTIONS.filter(
    (option) => option.id !== OFFER_SORT.NEWEST || canSortByNewest
  )

  const current = options.find((option) => option.id === sort) ?? options[0]

  const choose = (option) => {
    setOpen(false)
    if (option.id !== sort) {
      onChange(option.id)
    }
  }

  // The Drawer renders on the body, above the tab bar and the Continue bar, and handles the
  // backdrop, Escape, the focus trap and returning focus to the chip.
  return (
    <div className="gamesRedesignSort">
      <button
        type="button"
        className={`gamesRedesignSortChip ${isOpen ? 'open' : ''}`}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
        aria-controls="games-sort-offers"
        onClick={() => setOpen(true)}
      >
        {current.label}
        <span className="gamesRedesignSortChipArrow" aria-hidden>
          ▾
        </span>
      </button>

      <Drawer
        anchor="bottom"
        open={isOpen}
        onClose={() => setOpen(false)}
        sx={{ zIndex: 1300 }}
        PaperProps={{
          id: 'games-sort-offers',
          role: 'dialog',
          'aria-modal': true,
          'aria-label': 'Sort offers',
          className: 'gamesRedesignSortSheet',
          sx: { maxHeight: '72vh', boxShadow: '0 -4px 7.2px rgba(0, 0, 0, 0.1)' },
        }}
      >
        <header className="gamesRedesignSortHeader">
          <h2 className="gamesRedesignSectionTitle">Sort offers</h2>
          <button
            type="button"
            className="gamesRedesignSortClose"
            aria-label="Close sort offers"
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </button>
        </header>
        <ul className="gamesRedesignSortOptions">
          {options.map((option) => (
            <li key={option.id}>
              <button
                type="button"
                className={`gamesRedesignSortOption ${option.id === current.id ? 'selected' : ''}`}
                aria-pressed={option.id === current.id}
                onClick={() => choose(option)}
              >
                <span className="gamesRedesignSortOptionTitle">{option.title}</span>
                <span className="gamesRedesignSortOptionDescription">{option.description}</span>
              </button>
            </li>
          ))}
        </ul>
      </Drawer>
    </div>
  )
}

export default SortOffers
